/** localStorage: this browser has completed at least one successful portal login (UX only, not auth). */
export const PORTAL_RETURNING_USER_STORAGE_KEY = 'club4x4_has_used_portal'

/** Record that this browser has authenticated with the portal before (survives sign-out). */
export function markPortalReturningUser(): void {
  try {
    localStorage.setItem(PORTAL_RETURNING_USER_STORAGE_KEY, '1')
  } catch {
    // Private mode / quota — ignore; first-time vs returning routing falls back safely.
  }
}

/** True when {@link markPortalReturningUser} was set on a prior successful login on this browser. */
export function hasPortalReturningUser(): boolean {
  try {
    return localStorage.getItem(PORTAL_RETURNING_USER_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}
